var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadImgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 26.316 21.211",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M24.94,21.211H1.305A1.617,1.617,0,0,1,0,19.722V4.257c0-.467.6-1.419,1.3-1.419H8.038V1.206A2.011,2.011,0,0,1,9.893,0h6.458c.28,0,1.924.561,1.924,1.206V2.838H24.94a1.707,1.707,0,0,1,1.373,1.49V19.65a1.381,1.381,0,0,1-.429.991A1.576,1.576,0,0,1,24.94,21.211ZM13.462,6.336a5.544,5.544,0,1,0,5.544,5.544A5.55,5.55,0,0,0,13.462,6.336Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadImgIcon);
export default __webpack_public_path__ + "static/media/upload-img-icon.0f9cb5c281b2dd8566b8ef28d44fe257.svg";
export { ForwardRef as ReactComponent };